// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"599f76a2","856":"7609651a","952":"9eb2e8ed"}[chunkId] + ".chunk.js";
};